import { ACTIVITY_TYPES } from "Constants/constants";

export const OVERLAY_ACTIVITY_TYPES = [
  ACTIVITY_TYPES.ENVIRONMENT.PUSH,
  ACTIVITY_TYPES.ENVIRONMENT.MERGE,
  ACTIVITY_TYPES.ENVIRONMENT.SYNCHRONIZE,
  ACTIVITY_TYPES.ENVIRONMENT.REDEPLOY,
  ACTIVITY_TYPES.ENVIRONMENT.RESOURCES.UPDATE,
  ACTIVITY_TYPES.ENVIRONMENT.SUBSCRIPTION.UPDATE
];

export const ALERT_ACTIVITY_TYPES = [ACTIVITY_TYPES.ENVIRONMENT.ALERT];

export const colorBands = [
  "#653193",
  "#E35F94",
  "#3A7DFF",
  "#FF7F55",
  "#38485E",
  "#EEBC08",
  "#97DC97",
  "#39BEBE",
  "#6046FF",
  "#AE82FF"
];

/**
 * Number of URLs shown as individual top-hit entries. Matches colorBands length —
 * there is no color for the (N+1)th URL, so this is a hard cap.
 */
export const MAX_TOP_HITS = colorBands.length;

export const OTHER_URLS_COLOR = "#2f2f7e";

export const SERVICE_KIND = "service";
export const BASE_AUTOSCALING_KINDS = ["webapp", "worker"];

export const BASE_AUTOSCALING_CLASSES = ["app", "worker"];

export const BASE_AUTOSCALING_RESOURCE_TYPES = ["webapps", "workers"];
